// SubscriptionCompleted.tsx
import React, { useState } from 'react';

interface SubscriptionCompletedProps {
  // onComplete가 Promise를 반환하도록 수정
  onGoBack: () => void;
}

const SubscriptionCompleted: React.FC<SubscriptionCompletedProps> = ({
  onGoBack,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const handleComplete = async () => {
    setIsLoading(true);
    setError(null);
    setSuccess(true);
  };

  return (
    <div className="p-6 bg-white shadow-md h-[300px] flex flex-col justify-center items-center rounded-md max-w-[600px] w-full mt-[100px] mobile:mt-[160px] mb-[100px] text-center">
      <>
        <h2 className="text-3xl mobile:text-lg text-[#141414] Pretendard-Bold mb-2 mobile:mb-2">
          회원가입 완료
        </h2>
        <p className="mb-6 text-[#757575] Pretendard-Regular mobile:text-[13px]">
          축하합니다! 회원가입이 완료되었습니다.
        </p>
        <div className='flex items-center'>
        <button
          onClick={() => (window.location.href = '/login')} // 로그인 페이지로 이동
          className="bg-MainColor hover:bg-opacity-80 tracking-wide mobile:text-xs text-white Pretendard-Bold py-2 px-8 rounded mr-4 mobile:mr-2 disabled:bg-gray-400"
        >
          로그인하러 가기
        </button>
        <button
          onClick={() => (window.location.href = '/')} // 로그인 페이지로 이동
          className="bg-gray-300 hover:bg-gray-400 tracking-wide mobile:text-xs text-white Pretendard-Bold py-2 px-8 rounded"
        >
          홈으로 가기
        </button>
        </div>
      </>
    </div>
  );
};

export default SubscriptionCompleted;
